export const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";
export const STORAGE_BASE =
  process.env.REACT_APP_STORAGE_BASE ||
  (API.endsWith("/api") ? API.slice(0, -4) : "http://127.0.0.1:8000");
export const WA_SERVICE_URL =
  process.env.REACT_APP_WA_SERVICE_URL || "http://127.0.0.1:3001";

export const authHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
};

/** Headers para requests JSON (POST/PUT) */
export const jsonAuthHeaders = () => ({
  ...authHeaders(),
  "Content-Type": "application/json",
});

export const resolveStorageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${STORAGE_BASE}${url.startsWith("/") ? "" : "/"}${url}`;
};